import {PortExposuresItemChunk} from "../../chunks/types/PortExposuresItemChunk";
import {PortDirection} from "../types/PortDirection";
import {getPortDirectionFromPortExposureBodyChunk} from "./getPortDirectionFromPortExposureBodyChunk";

export function getPortDirectionFromPortExposuresItemChunk(
  portExposuresItemChunk: PortExposuresItemChunk
): PortDirection {
  const {
    captures: {
      1: portExposureBodyChunk
    }
  } = portExposuresItemChunk;
  return getPortDirectionFromPortExposureBodyChunk(portExposureBodyChunk);
}
